import React, { useEffect, useState } from "react";
import OrderFormTab from "./tabs/OrderFormTab";
import FlipkartSandboxImport from "./FlipkartSandboxImport";
import {
  marketplaceTabFields,
  customerTabFields,
  fulfillmentTabFields,
  financialTabFields,
  returnLineTabFields,
} from "./orderField";
import { toast } from "../../../components/AppToast";

const tabs = [
  { label: "Marketplace Information", fields: marketplaceTabFields },
  { label: "Customer Information", fields: customerTabFields },
  { label: "Fulfillment & Logistics Info", fields: fulfillmentTabFields },
  { label: "Financial & Settlement Info", fields: financialTabFields },
  { label: "Return / Replacement Details ", fields: returnLineTabFields },
];

export default function CreateOrderTabs({
  initialValues = {},
  onCancel,
  onSubmit = () => {},
  isEdit = false,
  viewOnly = false,
}) {
  const readOnly = !!viewOnly;
  const [activeTab, setActiveTab] = useState(0);
  const [formData, setFormData] = useState({});
  const [formSubmissionAttempted, setFormSubmissionAttempted] = useState(false);

  useEffect(() => {
    if ((viewOnly || isEdit) && initialValues && Object.keys(initialValues).length) {
      setFormData({ ...initialValues });
    } else if (!isEdit && !viewOnly) {
      setFormData({});
    }
  }, [initialValues, viewOnly, isEdit]);

  const handleChange = (e) => {
    if (readOnly) return;
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    if (readOnly) return;

    setFormSubmissionAttempted(true);

    try {
      const payload = { ...formData };
      if (!isEdit) {
        payload.omsOrderId = (payload.omsOrderId && String(payload.omsOrderId).trim()) || `OMS-${Date.now()}`;
      }
      if (!payload._id && !isEdit) {
        payload._id =
          typeof crypto !== "undefined" && crypto.randomUUID
            ? crypto.randomUUID()
            : `order-${Date.now()}`;
      }

      await onSubmit(payload, initialValues?._id);
      setFormSubmissionAttempted(false);
    } catch (err) {
      toast.error(err?.data?.message || err?.message || "Error saving order");
    }
  };

  return (
    <form onSubmit={submit}>
      <ul className="nav nav-tabs mb-3 flex-wrap">
        {tabs.map((tab, index) => (
          <li className="nav-item" key={tab.label}>
            <button
              type="button"
              className={`nav-link ${activeTab === index ? "active" : ""}`}
              onClick={() => setActiveTab(index)}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>

      {!isEdit && !viewOnly && (
        <FlipkartSandboxImport
          onApply={(partial) => setFormData((prev) => ({ ...prev, ...partial }))}
        />
      )}

      <OrderFormTab
        fields={tabs[activeTab].fields}
        formData={formData}
        onChange={handleChange}
        viewOnly={readOnly}
        formSubmissionAttempted={formSubmissionAttempted}
      />

      <div className="d-flex justify-content-center gap-2 mt-4">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Back
        </button>
        {!viewOnly && !isEdit && (
          <button type="submit" className="btn btn-primary">
            Save
          </button>
        )}
        {isEdit && !viewOnly && (
          <button type="submit" className="btn btn-primary">
            Update
          </button>
        )}
      </div>
    </form>
  );
}
